<style lang="stylus">
@import '../../../../stylesheet/variable.styl'
.cf-model
    height 100vh
    width 100%
    position fixed
    top 0px

    background-color rgba(0,0,0,0.2)
    .cf-box
        margin 200px auto 0
        border-radius 3px
        width 280px
        background-color #fff
        .message
            position relative
            text-align center
            height 73px
            line-height 73px
            color #191a1b
            font-size 15px
            margin 0
            &:after
                setBottomLine()
        .btn
            div
                height 48px
                line-height 48px
                width 137px
                text-align center
                display inline-block
                font-size 15px
            .sure
                border-radius 0 0 0 5px
            .cancel
                position relative
                color rgb(255,95,22)
                border-radius 0 0 5px 0
                &:after
                    setLeftLine()
</style>
<template>
<div class="cf-model">
    <div class="cf-box">
    <div class="message">确认放弃支付吗？</div>
        <div class="btn">
            <div class="sure" @click="leave">
                放弃
            </div>
            <div class="cancel" @click="stay">
                再想想
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        props: [ 'time'],
        data() {
            return {

            }
        },
        computed: {
            m() {
                if(!this.time){
                    return
                }
                return this.time.split(":")[0]
            },
            s() {
                if(!this.time){
                    return
                }
                return this.time.split(":")[1]
            }
        },
        methods: {
            leave() {
                this.$emit("close-cf", 'leave')
            },
            stay() {
                this.$emit("close-cf")
            }
        }
    }
</script>
